export default __webpack_public_path__ + "static/media/paper-capture3.103d615f.jpg";